import axios from "../libs/axios";
// import qs from "qs";
import authHeader from "./auth-header";

const END_POINT = `${process.env.VUE_APP_API_ENDPOINT}`;

class PreviewReserveService {
  async findInPreview(previewid) {
    console.log("+++ find");
    console.log(previewid);
    const result = await axios.get(
      END_POINT + `/v1/preview_reserve/preview/${previewid}`,
      {
        headers: authHeader(),
      },
    );
    return result;
  }
  async find(query) {
    console.log("+++ find");
    console.log(query);
    const result = await axios.get(END_POINT + `/v1/preview_reserve`, {
      params: query,
      headers: authHeader(),
    });
    return result;
  }

  findv2(params) {
    return axios.get(`${END_POINT}/v2/preview_reserve`, {
      headers: authHeader(),
      params: params,
    });
  }

  async findByID(id) {
    const result = await axios.get(END_POINT + `/v1/preview_reserve/${id}`, {
      headers: authHeader(),
    });
    return result;
  }

  async create(params,is_send_email) {
    console.log("+++ find");
    console.log(params);
    const newParams = { ...params, is_send_email };
    const result = await axios.post(END_POINT + `/v1/preview_reserve`, newParams, {
      headers: authHeader(),
    });
    return result;
  }

  async createByUser(params) {
    console.log("+++ createByUser");
    console.log(params);
    const result = await axios.post(
      END_POINT + `/v1/preview_reserve_user`,
      params,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async createByUser2(params) {
    console.log("+++ createByUser2");
    console.log(params);
    const result = await axios.post(
      END_POINT + `/v2/preview_reserve_user`,
      params,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async update(params,is_send_email) {
    const newParams = { ...params, is_send_email };
    console.log("+++ update");
    console.log(newParams);

    const result = await axios.put(
      END_POINT + `/v1/preview_reserve/${params._id}`,
      newParams,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async remove(id, isAdmin) {
    const result = await axios.delete(END_POINT + `/v1/preview_reserve/${id}`, {
      headers: authHeader(),
      data: { isAdmin },
    });
    return result;
  }
}

export default new PreviewReserveService();
